import $ from 'jquery';

$(function() {
    var requiredBillingFields = [
        "#BillingAddress_FirstName",
        "#BillingAddress_LastName",
        "#BillingAddress_Email",
        "#BillingAddress_Country",
    ];

    $("#EndOfWarrantyOrderForm #IsSameBillingAddress").on("change", function(el) {
        if (this.checked) {
            $("#BillingInformation").addClass("hidden");
            for (var i = 0; i < requiredBillingFields.length; ++i) {
                $(requiredBillingFields[i]).prop("required", false);
            }
        } else {
            $("#BillingInformation").removeClass("hidden");
            for (var i = 0; i < requiredBillingFields.length; ++i) {
                $(requiredBillingFields[i]).prop("required", true);
            }
        }
    });
});